import { apiWobaBackend } from "@/services/api-woba-backend";
import { isFirstDayOfMonth } from "date-fns";
import { GetProRataCreditsResponseApi } from "./get-pro-rata-credits.types";

export const GetProRataCredits = async (
  startDate: string,
  credits: number,
  companyId: number,
) => {
  if (!isFirstDayOfMonth(startDate)) {
    try {
      const response: GetProRataCreditsResponseApi = await apiWobaBackend.get(
        `/companies/${companyId}/packages/calculate-pro-rata-credits?start_date=${startDate}&credits=${credits}`,
      );
      return response.data.credits;
    } catch (error) {
      console.error("Failed to fetch pro-rata credits:", error);
      throw error;
    }
  }

  return credits;
};
